var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { __decorate, __metadata } from "tslib";
import ApiService from '@/core/services/ApiService';
import { Mutations, Actions } from '@/store/enums/StoreEnums';
import { Mutation, Action, Module, VuexModule } from 'vuex-module-decorators';
const API_URLS = {
    getLandingPage: `${process.env.VUE_APP_BASE_URL_DIGITAL}/hr-usermanagement/api/user/landingpage?ver=v1`
};
// const deviceList = [
//   /Android/i,
//   /webOS/i,
//   /iPhone/i,
//   /iPad/i,
//   /iPod/i,
//   /BlackBerry/i,
//   /Windows Phone/i
// ]
// const checkIsMobile = deviceList.some((deviceListItem) => {
//   return navigator.userAgent.match(deviceListItem)
// })
const filterLandingMenu = (target, filter) => {
    if (target.subGroup) {
        const subGroup = target.subGroup.map((subGroup) => {
            subGroup.menu = subGroup.menu.filter((menu) => {
                return menu.menuName.toLowerCase().includes(filter.toLowerCase());
            });
            return subGroup;
        });
        target.subGroup = subGroup.filter((subGroup) => {
            return subGroup.menu.length > 0;
        });
    }
    return target;
};
let MenuModule = class MenuModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.menu = [];
        this.page = 'Daftar Pekerjaan';
        this.isSideActive = true;
        this.lang = 'en';
        this.isSidebarHasMenu = false;
        this.landingMenu = [];
        this.sideMenuNew = [];
        this.landingFilter = '';
        this.asideFilter = '';
    }
    /**
     * Get list menu
     */
    get getAllMenu() {
        return this.landingMenu;
    }
    get getListFinanceLanding() {
        const financeMenu = JSON.parse(JSON.stringify(this.landingMenu)).find((el) => {
            return el.groupName === 'Finance Service';
        }) || {};
        if (this.landingFilter) {
            filterLandingMenu(financeMenu, this.landingFilter);
        }
        return financeMenu;
    }
    get getListPSCMLanding() {
        const pscmMenu = JSON.parse(JSON.stringify(this.landingMenu)).find((el) => {
            return el.groupName === 'PSCM Service';
        }) || {};
        if (this.landingFilter) {
            filterLandingMenu(pscmMenu, this.landingFilter);
        }
        return pscmMenu;
    }
    get getListHRGSLanding() {
        const hrgsMenu = JSON.parse(JSON.stringify(this.landingMenu)).find((el) => {
            return el.groupName === 'HR GS Service';
        }) || {};
        if (this.landingFilter) {
            filterLandingMenu(hrgsMenu, this.landingFilter);
        }
        return hrgsMenu;
    }
    // get getIsMobile(): boolean {
    //   return checkIsMobile
    // }
    get getIsSideActive() {
        return this.isSideActive;
    }
    // get getLang(): string {
    //   return this.lang
    // }
    get getSideMenuList() {
        const sideMenu = JSON.parse(JSON.stringify(this.sideMenuNew));
        if (this.asideFilter) {
            if (sideMenu.menu) {
                const menu = sideMenu.menu.map((menu) => {
                    menu.subMenu = menu.subMenu.filter((subMenu) => {
                        return subMenu.subMenuName
                            .toLowerCase()
                            .includes(this.asideFilter.toLowerCase());
                    });
                    return menu;
                });
                sideMenu.menu = menu.filter((menu) => {
                    return menu.subMenu.length > 0;
                });
            }
        }
        return sideMenu;
    }
    [_a = Mutations.SET_LANDING_FILTER](keyword) {
        this.landingFilter = keyword;
    }
    [_b = Mutations.SET_ASIDE_FILTER](keyword) {
        this.asideFilter = keyword;
    }
    [_c = Mutations.SET_ACTIVE_PAGE](newpage) {
        this.page = newpage;
    }
    [_d = Mutations.SET_LANDING_MENU](menu) {
        if (menu.length > 0) {
            const filteredMenu = menu.filter((obj) => {
                return (obj.groupName === 'HR GS Service' ||
                    obj.groupName === 'Finance Service' ||
                    obj.groupName === 'PSCM Service');
            });
            this.landingMenu = filteredMenu;
        }
    }
    [_e = Mutations.SET_SIDE_MENU](newlist) {
        this.sideMenuNew = newlist;
    }
    [_f = Mutations.RESET_MENU_LIST]() {
        this.landingMenu = [];
    }
    [_g = Mutations.SET_IS_SIDE_ACTIVE](status) {
        this.isSideActive = status;
    }
    [_h = Actions.ACTIVE_PAGE](newpage) {
        this.context.commit(Mutations.SET_ACTIVE_PAGE, newpage);
    }
    [_j = Actions.SET_IS_SIDE_ACTIVE](status) {
        this.context.commit(Mutations.SET_IS_SIDE_ACTIVE, status);
    }
    [_k = Actions.SIDE_MENU](sidemenu) {
        // NOTE: FOR FUTURE ENHANCEMENT, CONSIDER UPDATE MENU LIST FROM BE
        // #region mapping existing menu on bspace2
        if (this.page === 'HR & GS' || this.page === 'hrgs') {
            if (sidemenu.subGroupName === 'Analytic') {
                const findAssessmentAnalytic = sidemenu.menu.find((x) => {
                    return x.menuName == 'Assessment Analytic';
                });
                findAssessmentAnalytic.subMenu = [
                    {
                        subMenuID: 1,
                        subMenuName: 'Assessment Dashboard',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'hrgsdashboard'
                    },
                    {
                        subMenuID: 2,
                        subMenuName: 'Assessment Report',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'hrgsreport'
                    }
                ];
            }
            else if (sidemenu.subGroupName === 'Configuration') {
                const findMasterAssessment = sidemenu.menu.find((x) => {
                    return x.menuName == 'Assessment Master';
                });
                findMasterAssessment.subMenu = [
                    {
                        subMenuID: 1,
                        subMenuName: 'Form Builder',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'formbuilder'
                    },
                    {
                        subMenuID: 2,
                        subMenuName: 'Master Assessor',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'asesor'
                    },
                    {
                        subMenuID: 3,
                        subMenuName: 'Master Position Mapping',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'positionmapping'
                    },
                    {
                        subMenuID: 4,
                        subMenuName: 'Assessment Schedule',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'assessmentschedule'
                    },
                    {
                        subMenuID: 5,
                        subMenuName: 'Pre Assessment Schedule',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'preassessment'
                    },
                    {
                        subMenuID: 6,
                        subMenuName: 'Master Unit Competency',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'competencyunit'
                    },
                    {
                        subMenuID: 7,
                        subMenuName: 'Master Schema',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'schema'
                    },
                    {
                        subMenuID: 8,
                        subMenuName: 'Master TUK',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'tuk'
                    }
                ];
            }
        }
        else if (this.page === 'Finance Service' ||
            this.page === 'financeservice') {
            if (sidemenu.subGroupName === 'Transaction') {
                const findProfilingMaster = sidemenu.menu.find((x) => {
                    return x.menuName == 'Profiling Capex';
                });
                findProfilingMaster.subMenu = [
                    {
                        subMenuID: 1,
                        subMenuName: 'Budget',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Budget'
                    },
                    {
                        subMenuID: 2,
                        subMenuName: 'Export',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Export'
                    }
                ];
            }
            else if (sidemenu.subGroupName === 'Configuration') {
                const findProfilingCapex = sidemenu.menu.find((x) => {
                    return x.menuName == 'Profiling Capex Master';
                });
                findProfilingCapex.subMenu = [
                    {
                        subMenuID: 1,
                        subMenuName: 'Main Category',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Main Category'
                    },
                    {
                        subMenuID: 2,
                        subMenuName: 'Asset Category',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Asset Category'
                    },
                    {
                        subMenuID: 3,
                        subMenuName: 'Group',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Group'
                    },
                    {
                        subMenuID: 4,
                        subMenuName: 'Asset Profiling Class',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Asset Profiling Class'
                    },
                    {
                        subMenuID: 5,
                        subMenuName: 'Asset Profiling',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Asset Profiling'
                    },
                    {
                        subMenuID: 6,
                        subMenuName: 'Hierarchy Profiling',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Hierarchy Profiling'
                    },
                    {
                        subMenuID: 7,
                        subMenuName: 'Mapping Profiling',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Mapping Profiling'
                    },
                    {
                        subMenuID: 8,
                        subMenuName: 'Mapping Project',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Mapping Project'
                    }
                ];
                const findBudgetMaster = sidemenu.menu.find((x) => {
                    return x.menuName == 'Budget Master';
                });
                findBudgetMaster.subMenu = [
                    {
                        subMenuID: 1,
                        subMenuName: 'Define Current Version',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Define Current Version'
                    },
                    {
                        subMenuID: 2,
                        subMenuName: 'Budget Catalog',
                        subMenuIcon: 'media/svg/menu-icons/document.svg',
                        subMenuPathName: 'Tabs-Budget Catalog'
                    }
                ];
            }
        }
        // #endregion
        this.context.commit(Mutations.SET_SIDE_MENU, sidemenu);
    }
    [_l = Actions.GET_MENU]() {
        const config = {
            siteId: this.context.getters.currentUser.locationID,
            roles: this.context.getters.currentUser.roles,
            employeeId: this.context.getters.currentUser.employeeID
        };
        return new Promise((resolve, reject) => {
            ApiService.post(API_URLS.getLandingPage, config)
                .then(({ data }) => {
                this.context.commit(Mutations.SET_LANDING_MENU, data.result.content);
                resolve();
            })
                .catch(() => {
                reject();
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _l, null);
MenuModule = __decorate([
    Module
], MenuModule);
export default MenuModule;
